/*eslint indent: 0 */
// prettier-ignore
var all_number_keys = [
	// 0,  1,  2,  3,  4,  5,  6,  7,  8,  9
	  48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
	  96, 97, 98, 99,100,101,102,103,104,105
]
export default all_number_keys
